import {
  HttpClient,
  HttpContext,
  HttpHeaderResponse,
  HttpHeaders
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import {Observable, of, throwError} from 'rxjs';
import {catchError, map, switchMap, tap} from 'rxjs/operators';

import { environment } from 'src/environments/environment';

import { ResetCredential } from '../kuba/users/models/user';

import { ApplicationUi, LoggedUser } from '../_models/';
import { IdentityToken } from "../_models/identityToken";
import { UserService } from "./user.service";
import { StorageKeys } from "../_models/storageKeys";
import { CsrfResponse } from '../_models/authentication/csrfResponse';
import { SKIP_ERROR_TOAST } from '../shared/http-context-tokens';

@Injectable()
export class AuthenticationService {
  currentUser = new LoggedUser();
  appUi = new ApplicationUi();
  timeouts = [];
  time: any;
  device: any;
  csrfToken: string | null = null;
  constructor(private http: HttpClient, private router: Router, private userService: UserService) {}

  createAuthorizationHeader(headers: HttpHeaders): HttpHeaders {
    return headers.append('content-type', 'application/json');
  }


  login(username: string, password: string, ipAddress: any): Observable<IdentityToken> {
    let headers = new HttpHeaders();
    headers = this.createAuthorizationHeader(headers);

    return this.http
      .post<IdentityToken>(
        `${environment.BASE_URL}/authentication/login-web`,
        {
          Username: username,
          Password: password,
          ipAddress: ipAddress,
          device: 'Desktop',
        },
        { headers: headers, context: new HttpContext().set(SKIP_ERROR_TOAST, true) }
      )
      .pipe(
        switchMap((token: IdentityToken) => {
          if (token && token.Role && token.Role !== '') {
            this.userService.setIdentityToken(token);
            return [token];
          } else {
            return throwError(() => new Error('Invalid Role in IdentityToken'));
          }
        }),
        catchError((error) => {
          console.error('Login request failed', error);
          return throwError(() => error);
        })
      );
  }

  forgotPassword(username: string, languageId: number, applicationId: number): Observable<void> {
    return this.http.post<void>(
      `${environment.BASE_URL}/password-reset/forgot-password`,
      { Username: username, LanguageId: languageId, ApplicationId: applicationId },
      { context: new HttpContext().set(SKIP_ERROR_TOAST, true) }
    );
  }

  public getCsrfToken(): string | null {
      const token = localStorage.getItem(StorageKeys.IDENTITY_TOKEN);
      if (token) {
          return (JSON.parse(token) as IdentityToken).CsrfToken;
      }
      return null;
  }

  getUserIdByToken(credential: ResetCredential) {
    let headers = new HttpHeaders();
    this.createAuthorizationHeader(headers);
    return this.http
      .post(
        environment.BASE_URL + '/authentication/useridbytoken',
        credential,
        { headers: headers, context: new HttpContext().set(SKIP_ERROR_TOAST, true) }
      )
      .pipe(map((result) => result));
  }

  resetPassword(userCredential: any) {
    let headers = new HttpHeaders();
    this.createAuthorizationHeader(headers);
    return this.http
      .put(
        environment.BASE_URL + '/authentication/reset-password',
        userCredential,
        { headers: headers, context: new HttpContext().set(SKIP_ERROR_TOAST, true) }
      )
      .pipe(map((result) => result));
  }

  /**
   * Refreshes the identity token by sending a request to the server.
   *
   * If the request is successful, the new token is stored in local storage.
   */
  public refreshToken(): Observable<CsrfResponse> {
    return this.http.post<CsrfResponse>(
      `${environment.BASE_URL}/authentication/renew-token-web`, {}, { withCredentials: true }
    ).pipe(
      tap((response) => {
        this.userService.updateCsrfToken(response);
      })
    );
  }

  public logout() {
    const languageMode = localStorage.getItem('languageMode');
    const languageId = localStorage.getItem('languageId');

    sessionStorage.clear();
    localStorage.clear();

    if (languageMode) {
      localStorage.setItem('languageMode', languageMode);
    }
    if (languageId) {
      localStorage.setItem('languageId', languageId);
    }

    this.http.post(`${environment.BASE_URL}/authentication/logout-web`, {}).subscribe({
      next: (res) => {
        console.log('Logged out and cookies cleared', res);
      },
      error: (err) => {
        console.error('Error clearing cookies:', err);
      }
    });
    this.router.navigate(['login']);
  }

}
